import { render, staticRenderFns } from "./serialNumber.vue?vue&type=template&id=6032737b&"
import script from "./serialNumber.vue?vue&type=script&lang=js&"
export * from "./serialNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports